import { render, staticRenderFns } from "./OrderBeauty.vue?vue&type=template&id=0d93bd51&scoped=true"
import script from "./OrderBeauty.vue?vue&type=script&lang=js"
export * from "./OrderBeauty.vue?vue&type=script&lang=js"
import style0 from "./OrderBeauty.vue?vue&type=style&index=0&id=0d93bd51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d93bd51",
  null
  
)

export default component.exports